import axios from 'axios';
import type Profile from '../../models/Profile';
import { transformAzDomainsToArray, transformAzDomainsToString } from '../transformAzDomains';

export default class ProfileHelper {
  static baseUrl = `/api/profiles`;

  static getAll = async () => {
    const result = await axios.get<Profile[]>(this.baseUrl);

    const transformedProfiles = result.data.map((profile) => ({
      ...profile,
      formValues: transformAzDomainsToArray(profile.formValues),
    }));

    return {
      ...result,
      data: transformedProfiles,
    };
  };

  static get = async (id: number) => {
    const result = await axios.get<Profile>(`${this.baseUrl}/${id}`);
    const transformedProfile = {
      ...result.data,
      formValues: transformAzDomainsToArray(result.data.formValues),
    };

    return {
      ...result,
      data: transformedProfile,
    };
  };

  static create = async (ssoProfile: Pick<Profile, 'profileTypeId' | 'formValues'>) => {
    const transformedProfile = {
      ...ssoProfile,
      formValues: transformAzDomainsToString(ssoProfile.formValues),
    };
    const result = await axios.post<{ profile: Profile; configUrl?: string }>(
      this.baseUrl,
      transformedProfile,
    );

    const transformedResult = {
      ...result.data.profile,
      formValues: transformAzDomainsToArray(result.data.profile.formValues),
    };

    return {
      ...result,
      data: { ...result.data, profile: transformedResult },
    };
  };

  static delete = (id: number) => axios.delete(`${this.baseUrl}/${id}`);

  static update = async (ssoProfile: Profile, id: number) => {
    const transformedProfile = {
      ...ssoProfile,
      formValues: transformAzDomainsToString(ssoProfile.formValues),
    };

    const result = await axios.put<Profile>(`${this.baseUrl}/${id}`, transformedProfile);
    const transformedResult = {
      ...result.data,
      formValues: transformAzDomainsToArray(result.data.formValues),
    };

    return {
      ...result,
      data: transformedResult,
    };
  };
}
